export default __webpack_public_path__ + "static/media/hi-capa.8744a493.svg";